import Axios from "axios";
import {apiConstants} from "../constants/ApiConstants";

export const taskServices = {
    prefix: '',
    token: localStorage.getItem('token'),
    setPrefix,
    get,
    add,
    update,
    getSettings,
    run,
    stop,
    remove
};

function setPrefix(prefix) {
    this.prefix = prefix;
    return this;
}

function add(params) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    return Axios.post(apiConstants.API_URL + '/' + this.prefix + 'tasks', params, config)
        .then((response) => {
            return response;
        })
}

function update(id, params) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    return Axios.put(apiConstants.API_URL + '/' + this.prefix + 'tasks/' + id, params, config)
        .then((response) => {
            return response;
        })
}

function getSettings(handler) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token
        }
    };

    Axios.get(apiConstants.API_URL + '/' + this.prefix + 'settings', config)
        .catch()
        .then(response => {
            if (response.status === 200) {
                const result = response.data;
                if (result.status === 'success') {
                    const data = result.data;
                    handler(data)
                }
            }
        })
}

function get(id, handler) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    Axios.get(apiConstants.API_URL + '/' + this.prefix + 'tasks/' + id, config)
        .catch()
        .then(response => {
            if (response.status === 200) {
                const result = response.data;
                if (result.status === 'success') {
                    const data = result.data;
                    handler(data)
                }
            }
        })
}

function run(id) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const params = new URLSearchParams();
    params.append('action', 'run');

    return Axios.post(apiConstants.API_URL + '/' + this.prefix + 'tasks/' + id + '/actions', params, config)
        .then((response) => {
            return response;
        })
}

function stop(id) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const params = new URLSearchParams();
    params.append('action', 'stop');

    return Axios.post(apiConstants.API_URL + '/' + this.prefix + 'tasks/' + id + '/actions', params, config)
        .then((response) => {
            return response;
        })
}

function remove(id) {
    const config = {
        headers: {
            'Authorization': 'bearer ' + this.token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    return Axios.delete(apiConstants.API_URL + '/' + this.prefix + 'tasks/' + id, config)
        .then((response) => {
            return response;
        })
}